import React from "react";
import  * as AiIcons from 'react-icons/ai';
import  * as IoIcons from 'react-icons/io';



export const SidebarData = [
    {
        title : 'Home',
        path : '/',
        icons: <AiIcons.AiFillHome/>,
        cName: 'nav-text'
    },
    {
        title : 'Ambassadors',
        path : '/ambassadors',
        icons: <IoIcons.IoIosPaper/>,
        cName: 'nav-text'
    },
    {
        title : 'Team Sobr',
        path : '/teamsobr',
        icons: <IoIcons.IoMdPeople/>,
        cName: 'nav-text'
    },
    {
        title : 'Terms and Policy',
        path : '/terms&policy',
        icons: <IoIcons.IoMdPeople/>,
        cName: 'nav-text'
    }
]